import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const CDFAMarketingReportConfig = {
    auth: [...authRoles.admin],
    routes: [{ exact: true, path: '/cdfa-marketing-report', component: FuseLoadable({ loader: () => import('./ViewCDFAMarketingReportApp') }) }],
};

export default CDFAMarketingReportConfig;
